import {
  HeadContent,
  Scripts,
  createRootRouteWithContext,
} from "@tanstack/react-router";
import { ReactQueryDevtools } from "@tanstack/react-query-devtools";
import type { QueryClient } from "@tanstack/react-query";
import * as React from "react";

import { seo } from "@/utils/seo";
import appCss from "@/styles.css?url";
import { Analytics } from "@vercel/analytics/react";

export const Route = createRootRouteWithContext<{
  queryClient: QueryClient;
}>()({
  head: () => ({
    meta: [
      {
        charSet: "utf-8",
      },
      {
        name: "viewport",
        content: "width=device-width, initial-scale=1",
      },
      ...seo({ title: "Would You Rather Questions" }),
    ],
    links: [
      {
        rel: "stylesheet",
        href: appCss,
      },
      {
        rel: "icon",
        href: "/favicon.ico",
      },
    ],
  }),

  shellComponent: RootDocument,
});

function RootDocument({ children }: { children: React.ReactNode }) {
  // const queryClient = new QueryClient();
  React.useEffect(() => {
    const stored = localStorage.getItem("would_u_darkMode");
    setDarkMode(stored === null || stored === "true");

    const handleStorage = (event: StorageEvent) => {
      const stored = localStorage.getItem("would_u_darkMode");
      setDarkMode(stored === null || stored === "true");
    };

    window.addEventListener("storage", handleStorage);
    return () => {
      window.removeEventListener("storage", handleStorage);
    };
  }, []);

  const [darkMode, setDarkMode] = React.useState(true);
  return (
    <html lang="en">
      <head>
        <HeadContent />
      </head>
      <body className={`${darkMode ? "dark" : ""} h-screen min-h-screen`}>
        {children}
        <ReactQueryDevtools
          initialIsOpen={false}
          buttonPosition="bottom-right"
        />
        <Analytics />
        <Scripts />
      </body>
    </html>
  );
}
